<template>
  <div class="text-center p-3 px-md-4 py-md-3 text-md-left border rounded d-md-flex justify-content-between align-items-center">
      <div>
          <h3 class="mb-1">{{ title }}</h3>
          <p class="mb-2 mb-md-0">{{ text }}</p>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
        type: String,
        default: null
    },
    text: {
        type: String,
        default: null
    },
  },
  methods: {
      
  }
}
</script>